<template>
    <Success
        :payment="payment"
        :complete="complete"
        :user="user"
    />
</template>

<script>
import { mapState, mapActions } from 'vuex';

import Success from '@C/Enrolment/Success.vue';

export default {
    name: 'SuccessStandard',
    components: {
        Success
    },
    created() {
        this.loadPaymentConfirmation();
    },
    computed: {
        ...mapState('Enrolment', ['payment', 'user']),
    },
    methods: {
        ...mapActions('Enrolment', ['loadPaymentConfirmation', 'complete'])
    }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/stages/Enrolment/Success.vue